/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import Tour, { ReactourStep } from 'reactour';
import { setCookie } from 'services/actions/cookies_actions';

// import CookiesActions from '../actions/cookies_actions';

import './style.css';

interface OnboardingProps {
  tourSelect: string;
}

const Onboarding = ({ tourSelect }: OnboardingProps) => {
  const [steps, setSteps] = useState<Array<ReactourStep>>([]);
  const [isTourOpen, setIsTourOpen] = useState(true);
  const [showNavigation, setShowNavigation] = useState(true);
  const [showNumber, setShowNumber] = useState(true);
  const [showButtons, setShowButtons] = useState(true);
  const [isDisableInteraction, setIsDisableInteraction] = useState(false);

  function onboardingTour() {
    const steps = [
      {
        selector: '.tour-boletins-card',
        content: (
          <div>
            <p>
              Em <strong>Boletins de Licitações</strong> você encontrará diariamente novas
              oportunidades de licitações que surgiram e separamos para sua empresa. Elas são
              especialmente selecionadas de acordo com o segmento que você escolheu.
            </p>
            <p>
              Se não estiverem de acordo com suas necessidades, avise-nos, pois nossa maior
              especialidade é justamente selecionar e filtrar para você as melhores oportunidades.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-encontrar-licitacoes-card',
        content: (
          <div>
            <p>
              Em <strong>Encontrar Licitações</strong> você pode fazer pesquisas específicas, tendo
              à disposição diversos filtros para auxiliar na sua busca, visando obter resultados
              mais precisos.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-encontrar-acompanhamentos-card',
        content: (
          <div>
            <p>
              Para ver os resultados das licitações, acesse o{' '}
              <strong>Encontrar Acompanhamentos</strong>, onde você pode fazer pesquisas
              específicas, tendo à disposição diversos filtros para auxiliar na sua busca, visando
              obter resultados mais precisos.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-gerenciar-licitacoes-card',
        content: (
          <div>
            <p>
              Ao achar uma licitação perfeita para sua empresa, você pode adicioná-la ao{' '}
              <strong>Gerenciar Licitações</strong> e centralizar em um só lugar todas as
              informações, tarefas e documentos necessários para participar dela.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-gerenciar-documentos-card',
        content: (
          <div>
            <p>
              Em <strong>Gerenciar Documentos</strong> você encontra com facilidade toda a
              documentação necessária para sua habilitação.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-monitoramento-card',
        content: (
          <div>
            <p>
              Com a ferramenta <strong>Monitorar Chat</strong> você acompanha em um só lugar e em
              tempo real os pregões que a sua empresa participa. Temos mais de 40 portais sendo
              monitorados. Tudo isso para você não perder negócio.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-analise-mercado-card',
        content: (
          <div>
            <p>
              Em <strong>Análise de Mercado</strong> você tem acesso a vários dados e informações
              estratégicas para você planejar suas ações no mercado de licitações.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-dr-licita-card',
        content: (
          <div>
            <p>
              Conheça a ferramenta <strong>Dr. Licita</strong>.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-concorrentes-card',
        content: (
          <div>
            <p>
              Com a ferramenta <strong>Concorrentes</strong> você poderá pesquisar informações
              estratégicas do seu concorrente, como dados cadastrais, quadro societário, penalidades
              e, inclusive, licitações que essa empresa já venceu ou participou.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-consultoria-card',
        content: (
          <div>
            <p>
              Em <strong>Assessoria e Consultoria</strong>, você tem vários serviços que auxiliam no
              dia a dia do licitante.
            </p>
            <p>
              <strong>Assessoria Cadastral</strong> é um serviço que auxilia o licitante durante o
              processo de cadastramento em órgãos públicos.
            </p>
            <p>
              <strong>Em Jurídico Fácil</strong> você pode pesquisar jurisprudências, súmulas,
              legislações e dicas legais.
            </p>
            <p>
              Com a ferramenta <strong>Envie sua dúvida</strong> você pode tirar suas dúvidas com
              nosso time de advogados.
            </p>
            <p>
              Além disso, você pode acompanhar os <strong>Artigos Jurídicos</strong> escritos por
              nossa equipe de advogados.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-treinamento-card',
        content: (
          <div>
            <p>
              Aqui você pode conhecer nossos serviços de <strong>Treinamento e Capacitação.</strong>
            </p>
            <p>
              No <strong>ConLicitaGo</strong> você tem cursos, séries e formações sobre o mercado de
              licitações para assistir quando e onde quiser.
            </p>
            <p>
              O <strong>Cursos in Company</strong>, do Instituto Licitar, é uma capacitação na
              medida certa para preparar sua equipe para os desafios do mercado de licitações
              através de treinamentos adequados às necessidades da sua organização.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-api-card',
        content: (
          <div>
            <p>
              Com <strong>API ConLicitação</strong> você pode integrar as informações dos boletins
              com seus ERPs, CRMs, sistemas de gerenciamento de licitações e outros softwares de
              gestão de terceiros.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-emprego-card',
        content: (
          <div>
            <p>
              A <strong>Bolsa de Empregos do ConLicitação</strong> é um espaço exclusivo para que
              empresas fornecedoras do governo e profissionais especializados em licitações públicas
              divulguem oportunidades de emprego e currículos na área.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-ajuda-button',
        content: (
          <div>
            <p>
              Pronto! Agora você já pode começar a buscar os melhores negócios para a sua empresa.
            </p>
            <p>
              Caso tenha dúvidas, entre em contato com nossa equipe de atendimento ou acesse nossa
              central de ajuda.
            </p>
            <p>Um grande abraço e ótimos negócios!</p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
  }

  function onboardingTourHelpButton() {
    const steps = [
      {
        selector: '.tour-ajuda-button',
        content: (
          <div>
            <p>Aqui você encontra o passo a passo de como utilizar todas as ferramentas.</p>
            <p>Clique no botão para acessar.</p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(false);
    setShowNavigation(false);
  }

  function onboardingChatbot() {
    const steps = [
      {
        selector: '.tour-chatbot',
        content: (
          <div>
            <p>
              Acesse por aqui para conhecer nossa <strong>Especialista Virtual</strong>.
            </p>
            <p>
              Sempre que precisar de ajuda sobre o processo de licitação ela estará pronta para
              fornecer respostas precisas às suas perguntas.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(false);
    setSteps(steps);
    setShowButtons(false);
    setShowNavigation(false);
    setIsDisableInteraction(true);
  }

  function onboardingTourFindBiddings() {
    const steps = [
      {
        selector: '.tour-encontrar-licitacoes-card',
        content: (
          <div>
            <p>
              Defina seus parâmetros de pesquisa que o ConLicitação encontrará as oportunidades
              certas em segundos, buscando em mais de 6.000 fontes que divulgam licitações
              diariamente!
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-ajuda-button',
        content: (
          <div>
            <p>Se tiver dúvidas clique em ajuda e veja como utilizar o Encontrar licitação.</p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
  }

  function onboardingRepresented() {
    const steps = [
      {
        selector: '.tour-select-company',
        content: (
          <div>
            <p>Boas-vindas a Plataforma ConLicitação para Representantes.</p>
            <p>
              Selecione aqui a empresa desejada para poder visualizar e gerenciar as licitações
              referentes a ela.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(false);
    setSteps(steps);
    setShowButtons(false);
    setShowNavigation(false);
    setIsDisableInteraction(true);
  }

  function tourRemoveFavoritesBegin() {
    const steps = [
      {
        selector: '.tour-remove-favorites-select-begin',
        content: (
          <div>
            <p>
              <strong>Você sabia?</strong>
            </p>
            <p>
              Você pode desfavoritar suas licitações de forma rápida, seja em massa ou uma por uma,
              clicando em ”selecionar página”.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-remove-favorites-select-all',
        content: (
          <div>
            <p>
              <strong>Faça a seleção em massa:</strong>
              <br />
              Clique em selecionar página para selecionar todas as licitações dessa respectiva
              página.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-remove-favorites-select-one',
        content: (
          <div>
            <p>
              <strong>Ou opte pela seleção manual:</strong>
              <br />
              Selecione as licitações que deseja desfavoritar uma a uma ao clicar na caixa de
              seleção.
            </p>
            <p>Finalize essa instrução e veja como funciona!</p>
          </div>
        ),
      },
    ];
    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }
  function tourRemoveFavoritesEnd() {
    const steps = [
      {
        selector: '.tour-remove-favorites-select-all-link',
        content: (
          <div>
            <strong>Sobre desfavoritar suas licitações</strong>
            <br />
            <p>Você também pode selecionar as licitações de todas as páginas</p>
          </div>
        ),
      },
      {
        selector: '.tour-remove-favorites-button',
        content: (
          <div>
            <p>
              <strong>Agora é só remover!</strong>
              <br />
              Clique em ”remover do gerenciamento” e exclua todas as licitações selecionadas.
            </p>
            <p>Finalize essa instrução e veja como funciona!</p>
          </div>
        ),
      },
    ];
    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }

  function tourBeginDrLicita() {
    const steps = [
      {
        selector: '.tour-begin-dr-licita',
        content: (
          <div>
            <h5>Comece por aqui!</h5>
            <p>Clique no botão Criar uma nova petição para iniciar o processo.</p>
          </div>
        ),
      },
    ];

    setShowNumber(false);
    setSteps(steps);
    setShowButtons(false);
    setShowNavigation(false);
    setIsDisableInteraction(true);
  }

  function tourStepOneDrLicita() {
    const steps = [
      {
        selector: '.tour-drlicita-step-1',
        content: (
          <div>
            <p>Escolha o tipo de petição que deseja elaborar.</p>
          </div>
        ),
      },
      {
        selector: '.tour-drlicita-step-2',
        content: (
          <div>
            <p>Em seguida, indique a legislação aplicável.</p>
          </div>
        ),
      },
      {
        selector: '.tour-drlicita-step-3',
        content: (
          <div>
            <p>Agora, para criar sua petição, você pode optar por uma das seguintes formas:</p>

            <p>
              <strong>1.</strong> Digite o assunto que deseja encontrar. Ex.: Balanço Vencido. Mas
              não se preocupe, o Dr. Licita vai sugerir ideias para facilitar esse processo.
            </p>

            <p>
              <strong>2.</strong> Faça o upload de algum documento (Ex.: página do Edital) e
              adicione palavras-chave para o Dr. Licita encontrar a tese ideal para você.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-drlicita-step-4',
        content: (
          <div>
            <p>
              Após preencher todos os campos, clique em <strong>Próximo</strong> para avançar para a
              próxima etapa.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }

  function tourStepTwoDrLicita() {
    const steps = [
      {
        selector: '.tour-drlicita-step-5',
        content: (
          <div>
            <p>
              Aqui, você encontrará sugestões de teses jurídicas organizadas por relevância, com
              base nas informações fornecidas na etapa anterior.
            </p>

            <p>Para ver mais detalhes de cada tese, clique na seta à direita.</p>

            <p>
              Escolha as teses que melhor se aplicam ao seu caso, selecionando a caixinha à
              esquerda.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-drlicita-step-6',
        content: (
          <div>
            <p>
              Com as teses selecionadas, clique em <strong>Criar minha petição</strong> para gerar
              automaticamente a sua petição.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }

  function tourStepThreeDrLicita() {
    const steps = [
      {
        selector: '.tour-drlicita-step-7',
        content: (
          <div>
            <p>
              Pronto! Sua petição foi criada com base nas informações fornecidas. Aqui você pode
              revisar todo o conteúdo gerado.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-drlicita-step-8',
        content: (
          <div>
            <p>
              Você pode exportar sua petição nos formatos .pdf ou .docx, conforme a sua necessidade.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }

  function tourConcurrentsBegin() {
    const steps = [
      {
        selector: '',
        content: (
          <div>
            <h5>A ferramenta de Concorrentes está de cara nova!</h5>
            <p>Agora, analisar seus concorrentes ficou ainda mais fácil e visual.</p>
            <p>
              A nova versão da ferramenta traz melhorias que deixam as informações mais claras,
              organizadas e intuitivas. Você ganha em precisão, agilidade e uma experiência muito
              mais prática.
            </p>
            <p>
              Quer ver o que mudou? <br />
              Vem com a gente nesse tour pelas novidades.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-concurrents-begin',
        content: (
          <div>
            <p className="font-weight-bold">Comece por aqui!</p>
            <p>Preencha com o CNPJ que deseja analisar e clique em buscar.</p>
            <p>Finalize essa instrução e veja como funciona!</p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }

  function tourConcurrentsPage() {
    const steps = [
      {
        selector: '.tour-concurrents-dashboard',
        content: (
          <div>
            <p className="font-weight-bold">Dashboard</p>
            <p>
              Aqui você irá encontrar os dados mais importantes para analisar seu concorrente, desde
              itens vencidos até a sanções recebidas.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-concurrents-admin',
        content: (
          <div>
            <p className="font-weight-bold">Análise administrativa</p>
            <p>
              Na aba de análise administrativa você encontrará todos os dados institucionais do seu
              concorrente, como os sócios e suas empresas vinculadas, endereço, segmentos e muito
              mais!
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-concurrents-participation',
        content: (
          <div>
            <p className="font-weight-bold">Participações</p>
            <p>
              Tenha um panorama completo das participações do seu concorrente nas licitações, itens
              vencidos e valores praticados, modalidades e regiões.
            </p>
          </div>
        ),
      },
      {
        selector: '.tour-concurrents-sanction',
        content: (
          <div>
            <p className="font-weight-bold">Sanções</p>
            <p>
              Veja todas as sanções e penalizações que seu concorrente já recebeu, com detalhes do
              órgão, tipo de sanção, datas e arquivos.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(true);
    setSteps(steps);
    setShowButtons(true);
    setShowNavigation(true);
    setIsDisableInteraction(true);
  }

  function onboardingBiddingSummary() {
    const steps = [
      {
        selector: '.tour-bidding-summary',
        content: (
          <div>
            <h5>Alerta de novidade por aqui!</h5>
            <p>
              Conheça agora mesmo o <strong>Resumo do Edital</strong>, uma funcionalidade que
              utiliza inteligência artificial para destacar as principais informações do edital e
              facilitar a sua análise.
            </p>
          </div>
        ),
      },
    ];

    setShowNumber(false);
    setSteps(steps);
    setShowButtons(false);
    setShowNavigation(false);
  }

  function requestClose() {
    setIsTourOpen(false);
    if (tourSelect === 'onboardingRepresented') {
      setCookie('onboardingRepresented', true);
    }

    if (tourSelect === 'tourRemoveFavoritesBegin') {
      setCookie('tourRemoveFavoritesBegin', true);
    }
    if (tourSelect === 'tourRemoveFavoritesEnd') {
      setCookie('tourRemoveFavoritesEnd', true);
    }
    if (tourSelect === 'tourBeginDrLicita') {
      setCookie('tourBeginDrLicita', true);
    }

    if (tourSelect === 'tourStepOneDrLicita') {
      setCookie('tourStepOneDrLicita', true);
    }
    if (tourSelect === 'tourStepTwoDrLicita') {
      setCookie('tourStepTwoDrLicita', true);
    }
    if (tourSelect === 'tourStepThreeDrLicita') {
      setCookie('tourStepThreeDrLicita', true);
    }
    if (tourSelect === 'tourConcurrentsBegin') {
      setCookie('tourConcurrentsBegin', true);
    }
    if (tourSelect === 'tourConcurrentsPage') {
      setCookie('tourConcurrentsPage', true);
    }

    if (tourSelect === 'onboardingBiddingSummary') {
      setCookie('onboardingBiddingSummary', true);
    }
  }

  const toursFunctions: any = {
    onboardingTour,
    onboardingTourHelpButton,
    onboardingTourFindBiddings,
    onboardingChatbot,
    onboardingRepresented,
    tourRemoveFavoritesBegin,
    tourRemoveFavoritesEnd,
    tourBeginDrLicita,
    tourStepOneDrLicita,
    tourStepTwoDrLicita,
    tourStepThreeDrLicita,
    tourConcurrentsBegin,
    tourConcurrentsPage,
    onboardingBiddingSummary,
  };

  useEffect(() => {
    if (tourSelect) toursFunctions[tourSelect]();
  }, []);

  return (
    <Tour
      steps={steps}
      isOpen={isTourOpen}
      showNavigation={showNavigation}
      showNumber={showNumber}
      showButtons={showButtons}
      maskSpace={5}
      rounded={5}
      onRequestClose={requestClose}
      className="onboarding"
      disableInteraction={isDisableInteraction}
    />
  );
};

export default Onboarding;
